import { useEffect, useMemo, useState } from 'react';

import { useMessages } from '../../../hooks/use-messages';
import { evaluateWindow24h } from '../window-24h';

import type { ConversationDetail } from '../../../lib/types';
import type { Window24hState } from '../window-24h';

const TICK_MS = 60 * 1000;

/**
 * Item 27 — estado da janela 24h Meta da conversa (advisory, client-side v1).
 *
 * Lê o MESMO cache infinito de `useMessages` da ConversationPage (zero fetch
 * extra). Tick de 60s: a janela pode expirar com a tela aberta; inbound novo
 * invalida o cache de mensagens e o banner some sozinho.
 */
export function useWindow24h(conversation: ConversationDetail): Window24hState {
  const { messages, isLoading } = useMessages(conversation.id);
  const [tick, setTick] = useState(0);
  const isWhatsApp = conversation.channel === 'whatsapp-cloud-api';

  useEffect(() => {
    if (!isWhatsApp) return undefined;
    const id = window.setInterval(() => setTick((t) => t + 1), TICK_MS);
    return () => window.clearInterval(id);
  }, [isWhatsApp]);

  return useMemo(
    () =>
      evaluateWindow24h({
        channel: conversation.channel,
        messages,
        messagesLoaded: !isLoading,
      }),
    // `tick` nas deps força reavaliar `now` interno a cada 60s.
    [conversation.channel, messages, isLoading, tick],
  );
}
